import React from "react";
import './titleSection.css';

// ...... images .......
import chrome from "../../../assets/images/chrome.svg";


function TitleSection() {
   return(
       <div className="content-box home-title-sec text-align-center">
          <div className="main-title rubik-medium">
             Automate your product demos <br/> and process documentation
          </div>
          <div className="sub-title light-color">
             Showcase your product and its benefits in an engaging<br/> manner across platforms
          </div>
          <div className="flex hr-center">
             <div className="btn">Signup free now</div>
             {/*<div className="btn chrome-button flex margin-l-20 ">*/}
             {/*   <div className="icon chrome-icon"><img src={chrome} alt=""/></div>*/}
             {/*   <div className="app-color margin-l-10">Get chrome extension</div>*/}
             {/*</div>*/}
          </div>
       </div>
   )
}

export default TitleSection;
